import { Message } from "constants/messages";
import { Code, Utility } from "helpers/CalendarImports";
import React, { useState, useEffect } from "react";
import apiLogin from "services/loginInterceptors";
import { useNavigate } from "react-router-dom";
import { API } from 'helpers/ApiHelpers';
import { Name } from 'constants/fieldname';
import { ExamTemplate } from 'models/ExamTemplateModel';
import { Extract } from 'helpers/ExtractHelper'


const LoginPage: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [examTemplateData, setExamTemplateData] = useState<ExamTemplate[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();


  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    // Basic validation
    if (!username || !password) {
      alert("⚠️ Please enter both username and password.");
      return;
    }

    if (!username.includes('@')) {
      alert("⚠️ Invalid User Name");
      return;
    }

    const btnlogin = document.getElementById('btnLogin');
    if(btnlogin) {
      btnlogin.classList.add('spintext');
    }

    const url = Code.Path.SERVER + Code.Path.LOGIN;

    try {

        const userCredential = {
          user_login: username, 
          user_pass: password
        };
      
        console.log("----userCredential--->", userCredential);

        const response = await apiLogin.post(url, userCredential);

        console.log("----response--->", response);

        const data = response.data;

        console.log(Message.Title.DATA_RECEIVED, data);

        if (data && data.accessToken && data.refreshToken) {
          //setAccessToken(data.accessToken);
          //setRefreshToken(data.refreshToken);
          //setUserInfo(data.info);

          // Store tokens and info in localStorage directly after receiving data
          Utility.Storage.Set(Code.LocalKey.AccessToken, data.accessToken);
          Utility.Storage.Set(Code.LocalKey.RefreshToken, data.refreshToken);

          if (data.info) {
            Utility.Storage.Set(Code.LocalKey.CompanyKey, data.info.companyKey || "");
            Utility.Storage.Set(Code.LocalKey.LocationKey, data.info.locationKey || "");
            Utility.Storage.Set(Code.LocalKey.UserKey, data.info.userKey || "");
            Utility.Storage.Set(Code.LocalKey.DoctorKey, data.info.doctorKey || "");
            Utility.Storage.Set(Code.LocalKey.DoctorList, data.info.doctorList || "");
            Utility.Storage.Set(Code.LocalKey.EmployeeKey, data.info.employeeKey || "");
            Utility.Storage.Set(Code.LocalKey.CompanyName, data.info.companyName || "");
            Utility.Storage.Set(Code.LocalKey.LocationName, data.info.locationName || "");
            Utility.Storage.Set(Code.LocalKey.UserName, data.info.userName || "");
            Utility.Storage.Set(Code.LocalKey.PrivilegeList, data.info.privilegeList);
            Utility.Storage.Set(Code.LocalKey.SpecialList, data.info.specialList);
            Utility.Storage.Set(Code.LocalKey.ReportList, data.info.reportList);
            Utility.Storage.Set(Code.LocalKey.FileList, data.info.fileList);

            const userId = Extract.Key.Decode(data.info.userKey);

            console.log("Logged in userId:::::::::::::::::::::>",userId);

            await callExamTemplateList(userId);

            navigate("/dashboard");
          }
        } else {
          if(btnlogin) {
            btnlogin.classList.remove('spintext');
          }
          console.error(Message.Title.TOKEN_NOT_FOUND);
          alert("⚠️ Incorrect username or password.");
        }
      } catch (error) {
        Utility.Handle.Error(error);
      }

    
  };

  const callExamTemplateList = async (userId:number) => {
    if(userId){
      const url = API.Build.FormApiEndpint(Code.Form.Name.EXAMTEMPLATE, 0, Name.ExamTemplate.Name, Code.Option.Sort.ASC, {
        fields: Utility.Join.Fields([
          Name.ExamTemplate.Id,
          Name.ExamTemplate.Name,
          Name.ExamTemplate.Data, 
        ]),
        [Name.User.Id]: userId,
      });
      //console.log("Exam Template URL:::::::::::::::::::::>",url);
      await API.Data.List<ExamTemplate>(url, setExamTemplateData, setError, setLoading);
    }
    
  };

  useEffect(() => {
    if(examTemplateData.length > 0){
      const examValues = Utility.Clean.JsonObject(examTemplateData)
      //console.log("examValues:::::::::::::::::::::>",examValues);
      Utility.Storage.Set(Code.LocalKey.examValues, btoa(examValues));
      setExamTemplateData([]);
    }
  }, [examTemplateData]);

  return (
    <div className="login-wrapper">
      {/* Left side with background image + form */}
      <div className="login-left">
        <div className="login-form-box">
          <h2 className="login-title">USER SIGN-IN</h2>

          <form onSubmit={handleLogin}>
            {/* Username */}
            <div className="login-group">
              <label htmlFor="username">Login Id</label>
              <div className="input-icon">
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your login id"
                />
                <span className="icon"></span>
              </div>
            </div>

            {/* Password */}
            <div className="login-group">
              <label htmlFor="password">Password</label>
              <div className="input-icon">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                />
                <span
                  className="icon clickable"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "" : ""}
                </span>
              </div>
            </div>

           {/* Remember me */}
            <div className="remember-me">
              <input type="checkbox" id="remember" />
              <label htmlFor="remember">
                Remember my account on this device.
              </label>
            </div>

            {/* Login button */}
            <button type="submit" id="btnLogin" className="login-btn">
              Login
            </button>
          </form>
        </div>
      </div>

      {/* Right side with branding */}
      <div className="login-right">
        <div className="brand-box">
          <div className="brand-logo">
            <img src="assets/images/basic/logo-white.png" />
          </div>
          <p className="contact-info"><img src="assets/images/colored/email.svg"/> info@nextvizon.com</p>
          <p className="contact-info"><img src="assets/images/colored/web.svg"/> www.nextvizon.com</p>

          <div className="social-icons">
            <a href="https://www.facebook.com/nextvizon" target="_blank"><img src="assets/images/dark/facebook.svg"/></a>
            <a href="https://www.instagram.com/nextvizon" target="_blank"><img src="assets/images/dark/instagram.svg"/></a>
            <a href="https://x.com/nextvizon" target="_blank"><img src="assets/images/dark/twitter.svg"/></a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;